import React from 'react';

import { Alert as AntdAlert } from 'antd';

import { ConditionsReactivateJuridictionDto } from 'lib_api/lib/api/gen/api';

interface ConditionReactivateProps {
  conditions?: ConditionsReactivateJuridictionDto;
}

function ConditionReactivateJuridiction({
  conditions,
}: ConditionReactivateProps): React.ReactElement {
  const isAlreadyValid = conditions?.juridictionValid;
  const existsAlready = conditions?.unicity;

  const isInvalid: boolean = (isAlreadyValid || existsAlready) ?? false;

  return (
    <>
      {isInvalid && (
        <AntdAlert
          type="warning"
          className="alertInvalid"
          message={
            <>
              {isAlreadyValid && (
                <p className="alertInvalid--txt">
                  La juridiction est déjà valide.
                </p>
              )}
              {existsAlready && (
                <p className="alertInvalid--txt">La juridiction existe déjà.</p>
              )}
            </>
          }
        />
      )}
    </>
  );
}

export default ConditionReactivateJuridiction;
